<template>
  <div id="app">
    <!-- <router-view /> -->
    <!-- <keep-alive :include="includedComponents">
      <router-view></router-view>
    </keep-alive> -->
    <keep-alive>
      <router-view ref="routerView" v-if="$route.meta.keepAlive" :key="$route.path"></router-view>
    </keep-alive>
    <router-view ref="routerView" v-if="!$route.meta.keepAlive" />
    <div v-drag class="ai-robot" @mouseenter="robotMouseenter()" @mouseleave="robotMouseleave()">
      <div class="img-box"></div>
      <div
        class="desc"
        v-if="showRobotDesc"
        @mouseenter="robotMouseenter()"
        @mouseleave="robotMouseleave()"
        @click.stop="$goRobotPage()"
      >
        软田AI智能客服，7x24小时响应您的所有诉求，点击进入
      </div>
    </div>
  </div>
</template>

<script>
import store from './store';
import FillInFrom from '@/components/FillInFrom.vue';
import { getInfo } from '@/api/login';
import $bus from './eventBus.js';
export default {
  name: 'App',
  // components: { Messmodle },
  store,
  components: {
    FillInFrom,
  },
  computed: {
    includedComponents() {
      // 在这里根据需要设置需要缓存的组件名称
      // return ['add', 'Addnewdemands','Addnewdemandt'];
    },
  },
  data() {
    return {
      showRobotDesc: true,
      mouseEnter: false,
      hideTimer: null,
      showTimer: null,
      open_dia: false,
      token: '',
      cachePage: [],
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.name, '------27');
      const token = this.$store.state.user.token;
      this.token = token;
      if (this.token) {
        console.log(this.$route.path);
        this.getUserInfo();
      } else {
        this.token = '';
      }
    },
  },
  mounted() {
    this.timeTask();
    this.changPage();
  },
  methods: {
    getUserInfo() {
      getInfo().then(res => {
        const user_info = res.data.userinfo;
        const is_complete = user_info.is_complete;
        this.$store.dispatch('setUserInfo', user_info);
        // 1完善 2没完善
        if (is_complete == 1) {
          this.open_dia = false;
        } else {
          this.open_dia = true;
        }
      });
    },
    robotMouseenter() {
      this.showRobotDesc = true;
      this.mouseEnter = true;
    },
    robotMouseleave() {
      this.showRobotDesc = false;
      this.mouseEnter = false;
    },
    timeTask() {
      //需求：悬浮提示语三分钟弹出一下，弹出后一分钟隐藏
      this.showTimer = setInterval(() => {
        if (!this.mouseEnter) {
          if (!this.showRobotDesc) {
            this.showRobotDesc = true;
          }
        }
      }, 240000);
      setTimeout(() => {
        if (!this.mouseEnter) {
          if (this.showRobotDesc) {
            this.showRobotDesc = false;
          }
        }
        this.hideTimer = setInterval(() => {
          if (!this.mouseEnter) {
            if (this.showRobotDesc) {
              this.showRobotDesc = false;
            }
          }
        }, 240000);
      }, 60000);
    },
    changPage() {
      this.$nextTick(() => {
        // 打印的keep-alive组件实例在上图
        console.log(this.$refs.routerView, 2245222);
        // $bus.$on('removeCachePage', key => {
        //   /**
        //    * @param {Object} cache:类数组对象，存放缓冲的路由组件，键值对形，key为路由路径，value为路由组件Vnode
        //    * @param {Array} keys:数组，存放缓冲的路由组件的key,即路由路径
        //    * @param {String} key:字符串，路由组件的key，指定要删除的路由组件key值
        //    */
        //   const { cache, keys } = this.$refs.routerView.$vnode.parent.componentInstance;
        //   Object.prototype.hasOwnProperty.call(cache, key) &&
        //     (() => {
        //       // 点击tab关闭页面，移除对应页面缓冲
        //       delete cache[key];
        //       keys.splice(keys.indexOf(key), 1);
        //       console.log('%c 删除缓冲页面成功！', 'color:red');
        //     })();
        // });
      });
    },
  },
  destroyed() {
    this.hideTimer = null;
    this.showTimer = null;
  },
};
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .ai-robot {
    width: 100px;
    height: 100px;
    position: fixed;
    z-index: 2000;
    bottom: 20px;
    right: 10px;
    display: flex;
    align-items: center;
    animation: bounce-up 0.5s linear infinite;

    @keyframes bounce-up {
      25% {
        transform: translateY(4px);
      }
      50%,
      100% {
        transform: translateY(0);
      }
      75% {
        transform: translateY(-4px);
      }
    }

    @keyframes slideIn {
      0% {
        transform: translateX(-20%);
      }
      100% {
        transform: translateX(0%);
      }
    }

    .desc {
      position: absolute;
      right: 100px;
      display: flex;
      width: 430px;
      height: 60px;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      color: #ffffff;
      background: linear-gradient(329deg, #1783ff 0%, #33ceff 100%);
      border-radius: 100px 30px 0px 100px;
      animation: slideIn 0.5s 1;
    }

    .img-box {
      width: 80px;
      height: 80px;
      margin-left: 20px;
      background-image: url('~@/assets/images/solution/robotImg.gif');
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue